import { render, staticRenderFns } from "./bjgg.vue?vue&type=template&id=1720a726&scoped=true"
import script from "./bjgg.vue?vue&type=script&lang=js"
export * from "./bjgg.vue?vue&type=script&lang=js"
import style0 from "./bjgg.vue?vue&type=style&index=0&id=1720a726&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1720a726",
  null
  
)

export default component.exports